import { render } from "./MGWalletStack.vue?vue&type=template&id=1382c002&scoped=true"
import script from "./MGWalletStack.vue?vue&type=script&lang=js"
export * from "./MGWalletStack.vue?vue&type=script&lang=js"

import "./MGWalletStack.vue?vue&type=style&index=0&id=1382c002&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1382c002"]])

export default __exports__